import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className={"container-wrapper"}>
      Why are you here?
      <br />
      <Link to="/">Home</Link>
    </div>
  );
};

export default NotFound;
